// This file was automatically generated from print.activeProblemList.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.activeProblemList');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.ptProblems');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.activeProblemList.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  el8.template.print.currentAsOf(opt_data, output);
  output.append('<h1 class="documentTitle">Ongoing Problem List</h1>');
  el8.template.print.patientDemog(soy.$$augmentData(opt_data, {phrase: 'Seen', physicianName: opt_data.prescribingPhysician.name}), output);
  if (opt_data.problems.items.length) {
    output.append('<ol class="numberedList">');
    var ppList12120 = opt_data.problems.items;
    var ppListLen12120 = ppList12120.length;
    for (var ppIndex12120 = 0; ppIndex12120 < ppListLen12120; ppIndex12120++) {
      var ppData12120 = ppList12120[ppIndex12120];
      output.append('<li class="preserve item">');
      el8.template.ptdata.ptProblems.summary(ppData12120, output);
      output.append('</li>');
    }
    output.append('</ol>');
  } else {
    if (opt_data.problems.isDocumentedAsNone) {
      output.append('<p>');
      el8.template.ptdata.ptProblems.documentedAsNoneSummary(null, output);
      output.append('</p>');
    }
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
